import { NgModule } from '@angular/core';

import { BaseModule } from '../shared/base.module';

import { DomainsComponent } from './domains/domains.component';
import { PaginationModule } from '../shared/pagination/pagination.module';
import { DialogModule } from '../dialog/dialog.module';

// ngx-bootstrap modules
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ModalModule } from 'ngx-bootstrap/modal';
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import { MATERIALS } from '../app.materials';
import { BreadcrumbModule } from '../shared/breadcrumb/breadcrumb.module';
import { SelfReportSettingRoutesModule } from './self-report-setting.routes';
import { DomainsModalComponent } from './domains/domains-modal/domains-modal.component';
import { SymptomsComponent } from './symptoms/symptoms.component';
import { SymptomsModalComponent } from './symptoms/symptoms-modal/symptoms-modal.component';
import { DiagnosisComponent } from './diagnosis/diagnosis.component';
import { DiagnosisModalComponent } from './diagnosis/diagnosis-modal/diagnosis-modal.component';
import { SelfReportsComponent } from './self-report/self-reports.component';
import { SelfReportsModalComponent } from './self-report/self-reports-modal/self-reports-modal.component';
import { SrConfigurationModalComponent } from './self-report/sr-configuration-modal/sr-configuration-modal.component';
import { MatSliderModule } from '@angular/material/slider';
import { AdminSettingNavigationModule } from '../shared/admin-setting/navigation/navigation.module';
import { AppAdminSettingHeaderModule } from '../shared/admin-setting/header/header.module';
import { AppAdminSettingSearchModule } from '../shared/admin-setting/search/search.module';
import { EditModalHeaderActionModule } from '../shared/admin-setting/edit-modal-header-action/edit-modal-header-action.module';
import { LifeCircumstancesComponent } from './life-circumstance/life-circumstances.component';
import { ServiceProviderEditModalModule } from '../shared/admin-setting/edit-modal/edit-modal.module';
import { AppAdminSettingActionModule } from '../shared/admin-setting/actions/actions.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SrOverviewModalComponent } from './self-report/sr-overview-modal/sr-overview-modal.component';
import { GroupSelectionModalComponent } from './self-report/group-selection-modal/group-selection-modal.component';

@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        SelfReportSettingRoutesModule,
        PaginationModule,
        DialogModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        TypeaheadModule.forRoot(),
        BsDropdownModule.forRoot(),
        MatSlideToggleModule,
        BreadcrumbModule,
        MatSliderModule,
        AdminSettingNavigationModule,
        AppAdminSettingHeaderModule,
        AppAdminSettingSearchModule,
        AppAdminSettingActionModule,
        ServiceProviderEditModalModule,
        EditModalHeaderActionModule,
        BreadcrumbModule
    ],
    declarations: [
        DomainsComponent,
        DomainsModalComponent,
        SymptomsComponent,
        SymptomsModalComponent,
        DiagnosisComponent,
        DiagnosisModalComponent,
        SelfReportsComponent,
        SelfReportsModalComponent,
        SrConfigurationModalComponent,
        SrOverviewModalComponent,
        GroupSelectionModalComponent,
        LifeCircumstancesComponent
    ]
})

export class SelfReportSettingModule { }
